// This file was automatically generated from print.medOrders.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.medOrders');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.practices');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.patients');
goog.require('el8.template.render.medOrder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.multiTypeContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var oList14968 = opt_data.orderSetsList;
  var oListLen14968 = oList14968.length;
  for (var oIndex14968 = 0; oIndex14968 < oListLen14968; oIndex14968++) {
    var oData14968 = oList14968[oIndex14968];
    el8.template.print.medOrders.singleTypeContent(soy.$$augmentData(opt_data, {type: oData14968.type, orderSets: oData14968.orderSets}), output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.singleTypeContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.type == 'controlled') {
    output.append('<div class=\'');
    el8.template.print.medOrders.printableBodyClass(opt_data, output);
    output.append('\'>');
    var setList14979 = opt_data.orderSets;
    var setListLen14979 = setList14979.length;
    for (var setIndex14979 = 0; setIndex14979 < setListLen14979; setIndex14979++) {
      var setData14979 = setList14979[setIndex14979];
      el8.template.print.medOrders.controlledPageWrapper(soy.$$augmentData(opt_data, {orders: setData14979}), output);
    }
    output.append('</div>');
  } else if (opt_data.type == 'prescription') {
    output.append('<div class=\'');
    el8.template.print.medOrders.printableBodyClass(opt_data, output);
    output.append('\'>');
    var setList14988 = opt_data.orderSets;
    var setListLen14988 = setList14988.length;
    for (var setIndex14988 = 0; setIndex14988 < setListLen14988; setIndex14988++) {
      var setData14988 = setList14988[setIndex14988];
      el8.template.print.medOrders.rxPageWrapper(soy.$$augmentData(opt_data, {orders: setData14988, title: 'Prescription', isSamples: false}), output);
    }
    output.append('</div>');
  } else if (opt_data.type == 'otc') {
    output.append('<div class=\'');
    el8.template.print.medOrders.printableBodyClass(opt_data, output);
    output.append('\'>');
    var setList14999 = opt_data.orderSets;
    var setListLen14999 = setList14999.length;
    for (var setIndex14999 = 0; setIndex14999 < setListLen14999; setIndex14999++) {
      var setData14999 = setList14999[setIndex14999];
      el8.template.print.medOrders.rxPageWrapper(soy.$$augmentData(opt_data, {orders: setData14999, title: 'Over-The-Counter Meds', isSamples: false}), output);
    }
    output.append('</div>');
  } else if (opt_data.type == 'samples') {
    output.append('<div class=\'');
    el8.template.print.medOrders.printableBodyClass(opt_data, output);
    output.append('\'>');
    var setList15010 = opt_data.orderSets;
    var setListLen15010 = setList15010.length;
    for (var setIndex15010 = 0; setIndex15010 < setListLen15010; setIndex15010++) {
      var setData15010 = setList15010[setIndex15010];
      el8.template.print.medOrders.rxPageWrapper(soy.$$augmentData(opt_data, {orders: setData15010, title: 'Sample Meds', isSamples: true}), output);
    }
    output.append('</div>');
  } else if (opt_data.type == 'eRxCopy') {
    output.append('<div class=\'');
    el8.template.print.medOrders.printableBodyClass(opt_data, output);
    output.append('\'>');
    var setList15021 = opt_data.orderSets;
    var setListLen15021 = setList15021.length;
    for (var setIndex15021 = 0; setIndex15021 < setListLen15021; setIndex15021++) {
      var setData15021 = setList15021[setIndex15021];
      el8.template.print.medOrders.rxPageWrapper(soy.$$augmentData(opt_data, {orders: setData15021, title: 'ePrescription Copy', isSamples: false, isPatient: true}), output);
    }
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.rxPageWrapper = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.practice.state == 'NY') {
    el8.template.print.medOrders._rxPageNY(opt_data, output);
  } else if (opt_data.practice.state == 'OH') {
    el8.template.print.medOrders._rxPageOH(opt_data, output);
  } else if (opt_data.practice.state == 'SC') {
    el8.template.print.medOrders._rxPageSC(opt_data, output);
  } else if (opt_data.practice.state == 'WA') {
    el8.template.print.medOrders._rxPageWA(opt_data, output);
  } else if (opt_data.practice.state == 'AL') {
    el8.template.print.medOrders._rxPageAL(opt_data, output);
  } else if (opt_data.practice.state == 'MS') {
    el8.template.print.medOrders._rxPageAL(opt_data, output);
  } else {
    el8.template.print.medOrders._rxPage(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.controlledPageWrapper = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.nonFillable) ? '<div class="rxQuarterContainer1"><p class="nonFillableCopyOnly">NON FILLABLE COPY ONLY</p><p class="nonFillableCopyOnly">NON FILLABLE COPY ONLY</p></div><div class="rxQuarterContainer2"><p class="nonFillableCopyOnly">NON FILLABLE COPY ONLY</p><p class="nonFillableCopyOnly">NON FILLABLE COPY ONLY</p></div><div class="rxQuarterContainer3"><p class="nonFillableCopyOnly">NON FILLABLE COPY ONLY</p><p class="nonFillableCopyOnly">NON FILLABLE COPY ONLY</p></div><div class="rxQuarterContainer4"><p class="nonFillableCopyOnly">NON FILLABLE COPY ONLY</p><p class="nonFillableCopyOnly">NON FILLABLE COPY ONLY</p></div>' : '');
  if (opt_data.practice.id == 8.86298902532e11) {
    el8.template.print.medOrders._controlledPageCA(opt_data, output);
  } else {
    switch (opt_data.practice.state) {
      case 'NY':
        el8.template.print.medOrders._rxPageNY(opt_data, output);
        break;
      case 'CA':
        el8.template.print.medOrders._controlledPageCA(opt_data, output);
        break;
      case 'ME':
        el8.template.print.medOrders._controlledPageME(opt_data, output);
        break;
      case 'FL':
        el8.template.print.medOrders._controlledPageFL(opt_data, output);
        break;
      case 'SC':
        el8.template.print.medOrders._controlledPageSC(opt_data, output);
        break;
      case 'WA':
        el8.template.print.medOrders._controlledPageWA(opt_data, output);
        break;
      case 'IN':
        if (el8Globals.FEATURES.INControlledPrint) {
          el8.template.print.medOrders._controlledPageIN(opt_data, output);
        } else {
          el8.template.print.medOrders._controlledPage(opt_data, output);
        }
        break;
      case 'OH':
        el8.template.print.medOrders._rxPageOH(opt_data, output);
        break;
      case 'AL':
        el8.template.print.medOrders._rxPageAL(opt_data, output);
        break;
      case 'MS':
        el8.template.print.medOrders._rxPageAL(opt_data, output);
        break;
      default:
        el8.template.print.medOrders._controlledPage(opt_data, output);
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.printableBodyClass = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.practice.id == 8.86298902532e11 && opt_data.type == 'controlled') ? 'printableBodyCAControlled' : (opt_data.practice.state == 'NY' || opt_data.practice.state == 'SC') ? 'printableBodyNoMargin' : (opt_data.practice.state == 'CA' && opt_data.type == 'controlled') ? 'printableBodyCAControlled / * CA controlled printouts have their own margins */' : (opt_data.type == 'controlled') ? 'printableBodyNoMargin' : 'printableBodyRx / * and OTC/RX printouts have their own margins as well */');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._rxPage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak"><div class="rxUncontrolledContainer">');
  el8.template.print.header(opt_data, output);
  el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: opt_data.title}), output);
  var orderList15099 = opt_data.orders;
  var orderListLen15099 = orderList15099.length;
  for (var orderIndex15099 = 0; orderIndex15099 < orderListLen15099; orderIndex15099++) {
    var orderData15099 = orderList15099[orderIndex15099];
    el8.template.print.medOrders.prescriptionScript({index: orderIndex15099 + 1, order: orderData15099, isSamples: opt_data.isSamples}, output);
  }
  if (! opt_data.isPatient) {
    el8.template.print.signature(soy.$$augmentData(opt_data, {signDate: opt_data.orders[0].signDate}), output);
    if (opt_data.fax) {
      if (opt_data.pharmacy) {
        output.append('<div class="contactName">Pharmacy Information:</div>');
        el8.template.render.medOrder.pharmacy(opt_data.pharmacy, output);
      }
    }
  } else {
    el8.template.print.signature({localFsPath: opt_data.localFsPath, signPhysician: opt_data.signPhysician, signDate: opt_data.orders[0].signDate}, output);
    if (opt_data.pharmacy) {
      output.append('<div class="contactName">Your prescription was electronically sent to the following pharmacy:</div>');
      el8.template.render.medOrder.pharmacy(opt_data.pharmacy, output);
    }
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._rxPageOH = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak"><div class="rxUncontrolledContainer">');
  el8.template.print.header(opt_data, output);
  el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: opt_data.title}), output);
  var orderList15130 = opt_data.orders;
  var orderListLen15130 = orderList15130.length;
  for (var orderIndex15130 = 0; orderIndex15130 < orderListLen15130; orderIndex15130++) {
    var orderData15130 = orderList15130[orderIndex15130];
    el8.template.print.medOrders.prescriptionScript({index: orderIndex15130 + 1, order: orderData15130, isSamples: opt_data.isSamples}, output);
  }
  if (! opt_data.isPatient) {
    el8.template.print.signatureOH(soy.$$augmentData(opt_data, {signDate: opt_data.orders[0].signDate}), output);
    if (opt_data.fax) {
      if (opt_data.pharmacy) {
        output.append('<div class="contactName">Pharmacy Information:</div>');
        el8.template.render.medOrder.pharmacy(opt_data.pharmacy, output);
      }
    }
  } else {
    el8.template.print.signatureOH({localFsPath: opt_data.localFsPath, signPhysician: opt_data.signPhysician, signDate: opt_data.orders[0].signDate}, output);
    if (opt_data.pharmacy) {
      output.append('<div class="contactName">Your prescription was electronically sent to the following pharmacy:</div>');
      el8.template.render.medOrder.pharmacy(opt_data.pharmacy, output);
    }
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._rxPageNY = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15158 = opt_data.orders;
  var orderListLen15158 = orderList15158.length;
  for (var orderIndex15158 = 0; orderIndex15158 < orderListLen15158; orderIndex15158++) {
    var orderData15158 = orderList15158[orderIndex15158];
    if (orderData15158) {
      output.append('<div class="rxQuarterContainer rxQuarterContainerNY">');
      el8.template.print.header(opt_data, output);
      if (! opt_data.isPatient) {
        el8.template.print.signerNY(soy.$$augmentData(opt_data, {signDate: orderData15158.signDate}), output);
      }
      el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: ''}), output);
      el8.template.print.medOrders.prescriptionScript({index: orderIndex15158 + 1, order: orderData15158, isSamples: opt_data.isSamples}, output);
      if (! opt_data.isPatient) {
        el8.template.print.signatureNY(soy.$$augmentData(opt_data, {esignatureUrl: null, signDate: orderData15158.signDate}), output);
        if (opt_data.fax) {
          if (opt_data.pharmacy) {
            output.append('<div class="rxQuarterPharmacy">Pharmacy: ');
            el8.template.render.medOrder.pharmacySmall(opt_data.pharmacy, output);
            output.append('</div>');
          }
        }
      } else {
        el8.template.print.signatureNY({localFsPath: opt_data.localFsPath, signPhysician: opt_data.signPhysician, signDate: orderData15158.signDate}, output);
        if (opt_data.pharmacy) {
          output.append('<div class="rxQuarterPharmacy">Electronically sent to: ');
          el8.template.render.medOrder.pharmacySmall(opt_data.pharmacy, output);
          output.append('</div>');
        }
      }
      output.append('<p class="dawInstructionsNY">THIS PRESCRIPTION WILL BE FILLED GENERICALLY UNLESS PRESCRIBER WRITES \'d a w\' IN THE BOX BELOW.</p><div class="mddContainerNY"><div class="mddBoxNY"></div><p class="mddTextNY">MAXIMUM DAILY DOSE</p></div><div class="dawContainerNY"><div class="dawBoxNY"></div><p>Dispense as Written</p></div></div>');
    } else {
      output.append('<div class="rxQuarterContainer"><p class="rxVoid">VOID</p></div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._rxPageSC = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15202 = opt_data.orders;
  var orderListLen15202 = orderList15202.length;
  for (var orderIndex15202 = 0; orderIndex15202 < orderListLen15202; orderIndex15202++) {
    var orderData15202 = orderList15202[orderIndex15202];
    if (orderData15202) {
      output.append('<div class="rxQuarterContainer">');
      el8.template.print.header(opt_data, output);
      el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: ''}), output);
      el8.template.print.medOrders.prescriptionScript({index: orderIndex15202 + 1, order: orderData15202, isSamples: opt_data.isSamples}, output);
      if (! opt_data.isPatient) {
        if (opt_data.fax) {
          if (opt_data.pharmacy) {
            output.append('<div class="rxQuarterPharmacy">Pharmacy: ');
            el8.template.render.medOrder.pharmacySmall(opt_data.pharmacy, output);
            output.append('</div>');
          }
        }
        output.append('<div class="sigLineSCWrap"><div class="sigLineSCBlock"><div class="sigLineSCContent">', (opt_data.esignatureUrl && ! orderData15202.isAllowSubstitutions) ? '<img class="eSignatureImgQuarterPage" src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/><br />' : '', '<div class="sigLineSC"></div><p>Dispense as Written</p></div></div><div class="sigLineSCBlock"><div class="sigLineSCContent">', (opt_data.esignatureUrl && orderData15202.isAllowSubstitutions) ? '<img class="eSignatureImgQuarterPage" src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/><br />' : '', '<div class="sigLineSC"></div><p>Substitutions permitted</p></div></div>');
        el8.template.print.rxCredsSC(soy.$$augmentData(opt_data, {esignatureUrl: null, signDate: orderData15202.signDate}), output);
        output.append('</div>');
      } else {
        if (opt_data.pharmacy) {
          output.append('<div class="rxQuarterPharmacy">Electronically sent to: ');
          el8.template.render.medOrder.pharmacySmall(opt_data.pharmacy, output);
          output.append('</div>');
        }
      }
      output.append('</div>');
    } else {
      output.append('<div class="rxQuarterContainer"><p class="rxVoid">VOID</p></div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._rxPageWA = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15252 = opt_data.orders;
  var orderListLen15252 = orderList15252.length;
  for (var orderIndex15252 = 0; orderIndex15252 < orderListLen15252; orderIndex15252++) {
    var orderData15252 = orderList15252[orderIndex15252];
    if (orderData15252) {
      output.append('<div class="rxFullPageContainer">');
      el8.template.print.header(opt_data, output);
      el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: ''}), output);
      el8.template.print.medOrders.prescriptionScript({index: orderIndex15252 + 1, order: orderData15252, isSamples: opt_data.isSamples}, output);
      if (! opt_data.isPatient) {
        if (opt_data.fax) {
          if (opt_data.pharmacy) {
            output.append('<div class="contactName">Pharmacy: ');
            el8.template.render.medOrder.pharmacySmall(opt_data.pharmacy, output);
            output.append('</div>');
          }
        }
        output.append('<div class="sigLineWAWrap"><div class="sigLineWABlock"><div class="sigLineWAContent">', (opt_data.esignatureUrl && orderData15252.isAllowSubstitutions) ? '<img src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/><br />' : '', '<div class="sigLineWA"></div><p>Substitutions permitted</p></div></div><div class="sigLineWABlock"><div class="sigLineWAContent">', (opt_data.esignatureUrl && ! orderData15252.isAllowSubstitutions) ? '<img src="' + soy.$$escapeHtml(opt_data.esignatureUrl) + '"/><br />' : '', '<div class="sigLineWA"></div><p>Dispense as Written</p></div></div>');
        el8.template.print.rxCredsWA(soy.$$augmentData(opt_data, {esignatureUrl: opt_data.esignatureUrl, signDate: orderData15252.signDate}), output);
        output.append('</div>');
      } else {
        if (opt_data.pharmacy) {
          output.append('<div class="contactName">Electronically sent to: ');
          el8.template.render.medOrder.pharmacySmall(opt_data.pharmacy, output);
          output.append('</div>');
        }
      }
      output.append('</div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._rxPageAL = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak"><div class="rxUncontrolledContainer">');
  el8.template.print.header(opt_data, output);
  el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: opt_data.title}), output);
  var orderList15303 = opt_data.orders;
  var orderListLen15303 = orderList15303.length;
  for (var orderIndex15303 = 0; orderIndex15303 < orderListLen15303; orderIndex15303++) {
    var orderData15303 = orderList15303[orderIndex15303];
    el8.template.print.medOrders.prescriptionScript({index: orderIndex15303 + 1, order: orderData15303, isSamples: opt_data.isSamples}, output);
  }
  if (! opt_data.isPatient) {
    el8.template.print.signatureAL(soy.$$augmentData(opt_data, {signDate: opt_data.orders[0].signDate}), output);
    if (opt_data.fax) {
      if (opt_data.pharmacy) {
        output.append('<div class="contactName">Pharmacy Information:</div>');
        el8.template.render.medOrder.pharmacy(opt_data.pharmacy, output);
      }
    }
  } else {
    el8.template.print.signatureAL({localFsPath: opt_data.localFsPath, signPhysician: opt_data.signPhysician, signDate: opt_data.orders[0].signDate}, output);
    if (opt_data.pharmacy) {
      output.append('<div class="contactName">Your prescription was electronically sent to the following pharmacy:</div>');
      el8.template.render.medOrder.pharmacy(opt_data.pharmacy, output);
    }
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._controlledPage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15331 = opt_data.orders;
  var orderListLen15331 = orderList15331.length;
  for (var orderIndex15331 = 0; orderIndex15331 < orderListLen15331; orderIndex15331++) {
    var orderData15331 = orderList15331[orderIndex15331];
    if (orderData15331) {
      output.append('<div class="rxFullPageContainer">');
      el8.template.data.practices.header(opt_data.practice, output);
      el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: ''}), output);
      el8.template.print.medOrders.prescriptionScript({index: orderIndex15331 + 1, order: orderData15331, isSamples: opt_data.isSamples}, output);
      output.append('<div class="eSignatureWrapperDefault">');
      el8.template.print.signatureMulti(soy.$$augmentData(opt_data, {esignatureUrl: null, signDate: orderData15331.signDate}), output);
      output.append('</div></div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._controlledPageCA = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapCA pageBreak"><div class="physicianHeader">');
  el8.template.data.practices.header(opt_data.practice, output);
  output.append('</div><div class="patientDemographics"><p class="patientName emphasis">For: ');
  el8.template.ptdata.patients.fullName(opt_data.patient, output);
  output.append('</p>', (opt_data.patient.address) ? '<p>' + soy.$$escapeHtml(opt_data.patient.address) + '</p>' : '', (opt_data.patient.cityStateZip) ? '<p>' + soy.$$escapeHtml(opt_data.patient.cityStateZip) + '</p>' : '', (opt_data.patient.dob) ? '<p>D.O.B.: ' + soy.$$escapeHtml(opt_data.patient.dob) + '</p>' : '');
  if (opt_data.patient.primaryInsurance && opt_data.patient.primaryInsurance.isNonEmpty) {
    output.append('<p>Insurance: ');
    el8.template.ptdata.patients.insuranceSummary(opt_data.patient.primaryInsurance, output);
    output.append('</p>');
  }
  output.append('</div>');
  var orderList15376 = opt_data.orders;
  var orderListLen15376 = orderList15376.length;
  for (var orderIndex15376 = 0; orderIndex15376 < orderListLen15376; orderIndex15376++) {
    var orderData15376 = orderList15376[orderIndex15376];
    el8.template.print.medOrders.controlledScript({index: orderIndex15376 + 1, order: orderData15376}, output);
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._controlledPageIN = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15384 = opt_data.orders;
  var orderListLen15384 = orderList15384.length;
  for (var orderIndex15384 = 0; orderIndex15384 < orderListLen15384; orderIndex15384++) {
    var orderData15384 = orderList15384[orderIndex15384];
    output.append('<div class="rxFullPageContainerIN"><div class="INControlledPatientInfo"><div class="INControlledName">');
    el8.template.ptdata.patients.fullName(opt_data.patient, output);
    output.append('</div><table><tr><td class="INControlledAddress">', soy.$$escapeHtml(opt_data.patient.addressLine), ' ', soy.$$escapeHtml(opt_data.patient.cityStateZip), '</td><td><div class="INControlledDate">', soy.$$escapeHtml(orderData15384.startDate), '</div></td></tr></table></div>');
    el8.template.print.medOrders.prescriptionScript({index: null, order: orderData15384, isSamples: false, noRx: true, concise: true}, output);
    output.append('</div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._controlledPageME = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15405 = opt_data.orders;
  var orderListLen15405 = orderList15405.length;
  for (var orderIndex15405 = 0; orderIndex15405 < orderListLen15405; orderIndex15405++) {
    var orderData15405 = orderList15405[orderIndex15405];
    if (orderData15405) {
      output.append('<div class="rxQuarterContainer">');
      el8.template.data.practices.header(opt_data.practice, output);
      el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: ''}), output);
      el8.template.print.medOrders.prescriptionScript({index: orderIndex15405 + 1, order: orderData15405, isSamples: opt_data.isSamples}, output);
      output.append('<div class="eSignatureWrapperME">');
      el8.template.print.signatureMulti(soy.$$augmentData(opt_data, {esignatureUrl: null, signDate: orderData15405.signDate}), output);
      output.append('</div></div>');
    } else {
      output.append('<div class="rxQuarterContainer"><p class="rxVoid">VOID</p></div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._controlledPageSC = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15427 = opt_data.orders;
  var orderListLen15427 = orderList15427.length;
  for (var orderIndex15427 = 0; orderIndex15427 < orderListLen15427; orderIndex15427++) {
    var orderData15427 = orderList15427[orderIndex15427];
    if (orderData15427) {
      output.append('<div class="rxQuarterContainer">');
      el8.template.data.practices.header(opt_data.practice, output);
      el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: ''}), output);
      el8.template.print.medOrders.prescriptionScript({index: orderIndex15427 + 1, order: orderData15427, isSamples: opt_data.isSamples}, output);
      output.append('<div class="sigLineSCWrap"><div class="sigLineSCBlock"><div class="sigLineSCContent"><div class="sigLineSC"></div><p>Dispense as Written</p></div></div><div class="sigLineSCBlock"><div class="sigLineSCContent"><div class="sigLineSC"></div><p>Substitutions permitted</p></div></div>');
      if (opt_data.signPhysicianIdentifiers) {
        output.append('<div class="signatureCreds"><p class="signerTextDefault">', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), '</p>');
        el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
        output.append('</div>');
      }
      output.append('<div class="signatureCreds">');
      el8.template.print._supervisingPhysician(opt_data, output);
      output.append('</div></div></div>');
    } else {
      output.append('<div class="rxQuarterContainer"><p class="rxVoid">VOID</p></div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._controlledPageWA = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15460 = opt_data.orders;
  var orderListLen15460 = orderList15460.length;
  for (var orderIndex15460 = 0; orderIndex15460 < orderListLen15460; orderIndex15460++) {
    var orderData15460 = orderList15460[orderIndex15460];
    if (orderData15460) {
      output.append('<div class="rxFullPageContainer">');
      el8.template.data.practices.header(opt_data.practice, output);
      el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: ''}), output);
      el8.template.print.medOrders.prescriptionScript({index: orderIndex15460 + 1, order: orderData15460, isSamples: opt_data.isSamples}, output);
      output.append('<div class="sigLineWAWrap"><div class="sigLineWABlock"><div class="sigLineWAContent"><div class="sigLineWA"></div><p>Substitutions permitted</p></div></div><div class="sigLineWABlock"><div class="sigLineWAContent"><div class="sigLineWA"></div><p>Dispense as Written</p></div></div>');
      if (opt_data.signPhysicianIdentifiers) {
        output.append('<div class="signatureCreds"><p class="signerTextDefault">', (opt_data.signPhysicianName) ? soy.$$escapeHtml(opt_data.signPhysicianName) : soy.$$escapeHtml(opt_data.signPhysician.fullName), '</p>');
        el8.template.print._physicianIdentifiers({identifiersList: opt_data.signPhysicianIdentifiers}, output);
        output.append('</div>');
      }
      output.append('<div class="signatureCreds">');
      el8.template.print._supervisingPhysician(opt_data, output);
      output.append('</div></div></div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders._controlledPageFL = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrapNoMargin pageBreak">');
  var orderList15491 = opt_data.orders;
  var orderListLen15491 = orderList15491.length;
  for (var orderIndex15491 = 0; orderIndex15491 < orderListLen15491; orderIndex15491++) {
    var orderData15491 = orderList15491[orderIndex15491];
    if (orderData15491) {
      output.append('<div class="rxHalfContainer">');
      el8.template.data.practices.header(opt_data.practice, output);
      el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: ''}), output);
      el8.template.print.medOrders.prescriptionScript({index: orderIndex15491 + 1, order: orderData15491, isSamples: opt_data.isSamples}, output);
      output.append('<div class="eSignatureWrapperFL">');
      el8.template.print.signatureMulti(soy.$$augmentData(opt_data, {esignatureUrl: null, signDate: orderData15491.signDate}), output);
      output.append('</div></div>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.prescriptionScript = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.order) {
    el8.template.render.medOrder.prescription(soy.$$augmentData(opt_data.order, {index: opt_data.index, isPrintout: true, isSamples: opt_data.isSamples, noRx: opt_data.noRx, concise: opt_data.concise}), output);
    el8.template.print.medOrders.ssControlledRefillMsg(opt_data.order, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.controlledScript = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="prescriptionContainer"><div class="prescriptionNumber fl"><span class="rxLabel">Rx</span>', soy.$$escapeHtml(opt_data.index), '</div>');
  if (opt_data.order) {
    el8.template.print.medOrders.controlledScriptContent(opt_data.order, output);
  } else {
    output.append('<div class="prescriptionOrder"><div class="fr"><p>Authorized Refill(s): VOID</p></div><div class="mediumText"><p class="pb10 mediumText">** LEFT BLANK INTENTIONALLY **</p></div></div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.controlledScriptContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="prescriptionOrder"><div class="fr"><p class="textRight">Refill(s): ', (opt_data.authRefills) ? '<span class="mediumText el8Bold elt">' + soy.$$escapeHtml(opt_data.authRefills) + '</span>' : '<span class="mediumText el8Bold elt">0</span>', '</p></div><div class="mediumText"><p class="pb5 el8Bold">', (opt_data.type == 'Refill') ? 'Refill: ' : (opt_data.type == 'DoseChange') ? 'Change Order: ' : 'New Order: ', soy.$$escapeHtml(opt_data.displayedMedicationName), '</p><p class="smallText">Sig: ', soy.$$escapeHtml(opt_data.directions), '</p><p class="smallText">Qty: ');
  if (opt_data.quantity) {
    el8.template.ptdata.model.medOrder.displayQuantity(soy.$$augmentData(opt_data, {wordy: true}), output);
  } else {
    output.append('0');
  }
  output.append('</p>');
  if (opt_data.isAllowSubstitutions != null) {
    output.append('<p class="smallText el8Bold noMargin">');
    el8.template.ptdata.model.medOrder.substitutionsInstr(soy.$$augmentData(opt_data, {wordy: true}), output);
    output.append('</p>');
  }
  output.append((opt_data.pharmacyInstructions) ? '<div class="fieldSection"><p class="smallText">Instructions: ' + soy.$$escapeHtml(opt_data.pharmacyInstructions) + '</p></div>' : '', (opt_data.isPostDated) ? '<div class="fieldSection"><p class="smallText">Do not fill before: ' + soy.$$escapeHtml(opt_data.startDate) + '</p></div>' : '');
  if (opt_data.icd10Codes && opt_data.icd10Codes.length) {
    output.append('<p class="smallText">Dx (ICD-10): ');
    var icd10CodeList15576 = opt_data.icd10Codes;
    var icd10CodeListLen15576 = icd10CodeList15576.length;
    for (var icd10CodeIndex15576 = 0; icd10CodeIndex15576 < icd10CodeListLen15576; icd10CodeIndex15576++) {
      var icd10CodeData15576 = icd10CodeList15576[icd10CodeIndex15576];
      output.append((! (icd10CodeIndex15576 == 0)) ? ', ' : '', soy.$$escapeHtml(icd10CodeData15576));
    }
    output.append('</p>');
  }
  el8.template.print.medOrders.ssControlledRefillMsg(opt_data, output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.medOrders.ssControlledRefillMsg = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.details && opt_data.details.ssRefillRequestRefNumber) ? '<p class="tinyText el8SSMsg">Surescripts RxReference #: ' + soy.$$escapeHtml(opt_data.details.ssRefillRequestRefNumber) + '</p>' : '', (opt_data.details && opt_data.details.responseToControlledRx) ? '<p class="tinyText el8Italic el8SSMsg">This is in response to an electronic refill renewal request for a controlled substance.</p>' : '');
  if (!opt_sb) return output.toString();
};
